import Cookies from 'js-cookie'
import { set } from 'lodash'
export default {
  state: {
    id: 0,
    realName: '',
    superAdmin: 0,
    // 公司列表
    companyAccountInfo: [],
    defaultCompanyId: localStorage.getItem('defaultCompanyId') || '',
    defaultCompanyName: '',
    company: '',
    defaultCompanyAuthentFlag: '', // 当前企业是否认证认证标识（10 未认证、20 待认证、30 驳回、40 已认证）
    userId: '',
    userName: '',
    name: '',
    sex: '',
    mobile: '',
    email: '',
    code: '',
    jwtStr: '', // rdms 存储
    headPhoto: '',
    userAvatarUrl: '',
    userNickname: '', // 昵称
    isMail: false, // 邮箱是否认证
    isOpinion: false, // 建议是否认证
    isRegister: false, // 注册是否认证
    isSgin: false, // 是否签到
    sysDate: '', // 签到时间
    corpUserInfo: {}, // 是否企业用户
  },
  mutations: {
    defaultCompanyId (state, defaultCompanyId) {
      localStorage.setItem('defaultCompanyId', defaultCompanyId)
      state.defaultCompanyId = defaultCompanyId
    },
    defaultCompanyName (state, defaultCompanyName) {
      state.defaultCompanyName = defaultCompanyName
    },
    company (state, company) {
      state.company = company
    },
    defaultCompanyAuthentFlag (state, defaultCompanyAuthentFlag) {
      state.defaultCompanyAuthentFlag = defaultCompanyAuthentFlag
    },
    companyAccountInfo (state, companyAccountInfo) {
      state.companyAccountInfo = companyAccountInfo
    },
    userId (state, userId) {
      state.userId = userId
    },
    userName (state, userName) {
      state.userName = userName
    },
    name (state, name) {
      state.name = name
    },
    mobile (state, mobile) {
      localStorage.setItem('randomNumber', mobile)
      state.mobile = mobile
    },
    email (state, email) {
      state.email = email
    },
    headPhoto (state, headPhoto) {
      state.headPhoto = headPhoto
    },
    setJwtStr (state, jwtStr) {
      state.jwtStr = jwtStr
    },
    id (state, id) {
      state.id = id
    },
    setNameSpace (state, nameSpace) {
      state.nameSpace = nameSpace
    },
    setUserAvatarUrl (state, userAvatarUrl) {
      state.userAvatarUrl = userAvatarUrl
    },
    setIsMail (state, isMail = false) {
      state.isMail = isMail
    },
    setIsOpinion (state, isOpinion) {
      state.isOpinion = isOpinion
    },
    setIsRegister (state, isRegister) {
      state.isRegister = isRegister
    },
    setUserIsSgin (state, isSgin) {
      state.isSgin = isSgin
    },
    setUserSysDate (state, sysDate) {
      state.sysDate = sysDate
    },
    setUserNickname (state, userNickname) {
      state.userNickname = userNickname
    },
    setCorpUserInfo(state, corpUserInfo) {
      state.corpUserInfo = corpUserInfo
    }
  },
  actions: {
    companyList ({ state, commit }, companyList = []) {
      companyList = companyList.filter(item => {
        return !item.resignFlag
      })
      if (companyList && companyList.length !== 0) {
        let com = companyList.find(item => {
          return item.companyId === item.defaultCompanyId
        })
        commit('companyAccountInfo', companyList)
        commit('defaultCompanyId', companyList[0].defaultCompanyId)
        companyList.forEach((item, index) => {
          if (item.defaultCompany === '1') {
            commit('company', companyList[index])
          }
        })
        if (com) {
          commit('defaultCompanyName', com.companyName)
          commit('defaultCompanyId', com.companyId)
          commit('defaultCompanyAuthentFlag', com.authentFlag)
        } else {
          commit('defaultCompanyName', '')
          commit('defaultCompanyAuthentFlag', '')
        }
      } else {
        commit('defaultCompanyId', '')
        commit('defaultCompanyName', '')
        commit('defaultCompanyAuthentFlag', '')
        commit('companyAccountInfo', [])
      }
    },
    setUserInfo ({ state, commit }, userInfo) {
      if (userInfo) {
        commit('userId', userInfo.userId)
        commit('userName', userInfo.userName)
        commit('name', userInfo.name)
        commit('mobile', userInfo.mobile)
        commit('email', userInfo.email)
        commit('headPhoto', userInfo.headPhoto)
        commit('setJwtStr', userInfo.jwtStr)
        commit('id', userInfo.userId)
        commit('setNameSpace', userInfo.nameSpace)
        commit('setUserAvatarUrl', userInfo.userInfoEntity && userInfo.userInfoEntity.userAvatarUrl)
        commit('setUserNickname', userInfo.userInfoEntity && userInfo.userInfoEntity.userNickname)
        Cookies.set('userInfo', JSON.stringify(userInfo))
      } else {
        commit('userId', '')
        commit('userName', '')
        commit('name', '')
        commit('mobile', '')
        commit('email', '')
        commit('headPhoto', '')
        commit('setJwtStr', '')
        commit('id', '')
        commit('setNameSpace', '')
        commit('setUserAvatarUrl', '')
        commit('setUserNickname', '')
        Cookies.remove('userInfo')
      }
    },
    setUserStatus ({ commit }, userStatus) {
      if (userStatus) {
        commit('setIsMail', userStatus.isMail)
        commit('setIsOpinion', userStatus.isOpinion)
        commit('setIsRegister', userStatus.isRegister)
        commit('setUserIsSgin', userStatus.isSgin)
        commit('setUserSysDate', userStatus.sysDate)
      } else {
        commit('setIsMail', false)
        commit('setIsOpinion', false)
        commit('setIsRegister', false)
        commit('setUserIsSgin', false)
        commit('setUserSysDate', false)
      }
    }
  }
}
